document.addEventListener("DOMContentLoaded",()=>{

    const observer =
        new IntersectionObserver(

            entries=>{

                entries.forEach(entry=>{

                    if(entry.isIntersecting){

                        entry.target.classList.add("show");

                        observer.unobserve(entry.target);

                    }

                });

            },

            {
                threshold:.12
            }

        );

    document
        .querySelectorAll(".fx-product-card")
        .forEach((card,index)=>{

            observer.observe(card);

            card.style.transitionDelay =
                `${index*100}ms`;

        });

});